import React from "react";
import "./App.css";
import MyPdfViewer from "./MyPdfViewer";
import PDFSignature from "./PdfSign";
import ThankYou from "./ThankYou";
import PdfSign from "./PdfSign";
import UserinfofForm from "./ankitform";
import Test from "./Esign/TestPdf";

function App() {
  //return <UserinfofForm />;
  return <PdfSign />
}

export default App;
